/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-12-29 14:51:29
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2018-01-03 10:51:50
 */
// 商户详情
import fetch from '@/utils/fetch';
import {shop_url} from '@/global';
const getDetail = ({ companyId, page = 1, rows = 5, payType = 0, type = 0, start = '', end = '', orderId = 0 } = {}) => {
  const url = `${shop_url}/shop/cms/mch`;
  const data = {
    companyId,
    end,
    orderId,
    page,
    rows,
    start,
    type,
    payType
  };
  const method = 'post';
  return fetch({
    url,
    method,
    data
  })
}

// 商户提现记录
const getMoneyList = ({ id, page = 1, rows = 10, status = 10000, start = '', end = ''} = {}) => {
  const url = `${shop_url}/shop/cms/mch/withdraw`;
  const data = {
    id,
    page,
    rows,
    status,
    start,
    end
  };
  const method = 'post';
  return fetch({
    url,
    method,
    data
  })
}

export {
  getDetail,
  getMoneyList
}



// WEBPACK FOOTER //
// ./src/api/merchant/merDetail.js